<template>
  <div class="salary-scheme wrap1">
    <!-- 标题 -->
    <h2 class="common-title">{{ $t('1110') }}</h2>
    <!-- 内容 -->
    <div class="wrap-content">
      <!-- 操作栏 -->
      <div class="active-wrap">
        <el-button
          size="small"
          type="primary"
          @click="open('addVisible', true)"
          v-if="$p('menu.payroll.payroll_scheme.edit')"
          >{{ $t('1146') }}</el-button
        >
      </div>
      <!-- Table -->
      <el-table :data="tableData" :height="tableHeight">
        <!-- 方案名称 -->
        <el-table-column prop="name" :label="$t('1145')">
          <template slot-scope="scope">
            <p v-show="!scope.row.isShow" class="name">
              <span> {{ showName(scope.row) }} </span>
              <img
                @click="changeEdit(scope.row, true)"
                src="@/assets/img/icon_edit.png"
                alt=""
                v-if="$p('menu.payroll.payroll_scheme.edit')"
              />
            </p>
            <el-input
              class="name-input"
              :ref="scope.$index"
              v-model="scope.row.name"
              v-show="scope.row.isShow"
            ></el-input>
            <el-button v-show="scope.row.isShow" type="text" @click="changeEdit(scope.row, false, 'save')">{{
              $t('1907')
            }}</el-button>
          </template>
        </el-table-column>
        <!-- 结算类型 -->
        <el-table-column prop="type_txt" :label="$t('33')" width="264"></el-table-column>
        <el-table-column :label="$t('832')" width="216" class="operation">
          <template slot-scope="scope">
            <el-button
              class="operation"
              type="text"
              @click="handlerEdit(scope.row)"
              v-if="$p('menu.payroll.payroll_scheme.edit')"
              >{{ $t('71') }}</el-button
            >
            <el-button
              class="operation"
              type="text"
              @click="handleDel(scope.row, scope.$index)"
              v-if="$p('menu.payroll.payroll_scheme.delete')"
              >{{ $t('65') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <Pagination
      layout="total, prev, pager, next"
      :current-page="page.page"
      :total="page.total"
      :page-size="page.limit"
      @current-change="currentChangeHandle"
    >
    </Pagination>
    <!-- 详情页 -->
    <!-- <Detail :current="currentData" @close="open" /> -->
    <!-- modal -->
    <Addto :visible.sync="show.addVisible" :typeList="typeList" @handlerCreate="handlerCreate" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Addto from './modal/addto-scheme' // 新增计算薪资方案
// 接口API 获取方案列表 结算类型列表
import { getList, getTypeList, saveProject, delScheme } from '@/api/payroll/salary-scheme'
import Pagination from '../../../components/pagination'

export default {
  components: {
    Addto,
    Pagination
  },
  data() {
    return {
      show: {
        addVisible: false // 新增弹窗
      },
      tableData: [], // 表格数据
      // 分页相关
      page: {
        page: 1, // 当前页
        total: 0, // 总条数
        limit: 20
      },
      typeList: [], // 结算类型
      csrf_token: '',
      currentData: {} // 当前选中项
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapState({
      contentViewHeight: state => state.settings.contentViewHeight
    }),
    tableHeight() {
      return this.contentViewHeight - 104
    }
  },
  methods: {
    init() {
      this.getList()
      this.getTypeList()
    },
    async getTypeList() {
      const res = await getTypeList()
      const { data } = res
      this.typeList = data.type_list
      this.csrf_token = data.csrf_token
    },
    // 渲染名称
    showName(row) {
      if (row.isShow === undefined) row.isShow = false
      return row.name
    },
    // 新增方案
    async handlerCreate(params) {
      const msg = {
        ...params,
        csrf_token: this.csrf_token
      }
      const res = await saveProject(msg)
      this.show.addVisible = false
      if (res && res.code === 1) {
        this.$router.push({
          path: '/payroll/salary-edit/' + res.data.payroll_sub_project_scheme_id,
          query: { type: String(params.type) }
        })
      }
    },
    // 获取列表
    async getList() {
      const res = await getList(this.page)
      const { data } = res
      // 表格数据
      this.tableData =
        Array.isArray(data.list) &&
        data.list.map(item => {
          item.isShow = false
          return item
        })
      // 分页总条数
      this.$set(this.page, 'total', data.count)
    },
    // 过滤列表数据获取方案名称
    getMapresult(key) {
      key = Number(key)
      if (!this.typeList) return ''
      const res = this.typeList.filter(item => (item.key = key))
      return res && res[0] && res[0].txt
    },
    // 删除方案
    handleDel(row, index) {
      const $t = this.$t
      this.$confirm($t('1147'), $t('229'), {
        confirmButtonText: $t('131'),
        cancelButtonText: $t('66'),
        type: 'warning'
      }).then(() => {
        delScheme(row).then(() => {
          this.tableData.splice(index, 1)
        })
      })
    },
    // 编辑名称
    async changeEdit(row, state, status) {
      this.$set(row, 'isShow', state || false)
      // 如果status为真 则修改名称
      if (status) {
        saveProject({ ...row, csrf_token: this.csrf_token })
          .then(res => {
            this.csrf_token = res.data.csrf_token
          })
          .finally(res => {
            this.getList()
          })
      }
    },
    // 表格项编辑按钮
    handlerEdit(row) {
      this.$router.push({
        path: '/payroll/salary-edit/' + row.payroll_sub_project_scheme_id,
        query: { type: row.type }
      })
      this.currentData = row
    },
    // open or close modal
    open(key, value) {
      // 每次打开重新请求列表类型
      if (key === 'addVisible') {
        this.getTypeList()
        return this.$nextTick(() => this.$set(this.show, key, value))
      }
      this.$set(this.show, key, value)
    },
    // 分页触发
    currentChangeHandle(val) {
      this.page.page = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap-content {
  .active-wrap {
    text-align: right;
    margin-bottom: 20px;
  }
  .name {
    display: flex;
    align-items: center;
    img {
      width: 16px;
      margin-left: 5px;
      cursor: pointer;
    }
  }
  .name-input {
    max-width: 288px;
    margin-right: 10px;
  }
  .operation + .operation {
    margin-left: 24px;
  }
}
</style>
